import { Injectable } from '@angular/core';
import {
  Iconsumption,
  IconsumptionOBject,
  IconsumptionResponse,
  ItableConsumption,
  defaultFilter,
  tableData,
  tableInfo,
  consumptionValues,
  IMassiveConsumptionResponse,
  IMassiveConsumeTable,
  ILossPercentageResponse,
  IlossPercentageTable,
  IlossPercentageUpdate,
  IconsumptionHistoric,
  IComplexFilter,
  IComplexFilterResponse,
  IConsumptionStatus,
  IConsolidate,
  IConsolidateData,
  IConsuptionOptions,
  ILossTable,
  ILossInfo,
} from '../../interfaces/consumption.interface';
import { HttpService } from '../../services/http/http.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import {
  CONSUMPTION_FILTER_TYPES,
  LOSS_TYPES,
} from '../../const/consumption.const';
import { CONSUMPTION_SERVICES, ADMIN_SERVICES } from '../../const/http.const';
import { AppSettings } from '../../utils/app.settings';
import { finalize, Observable, Subject } from 'rxjs';
import e from 'express';
import { MatDialog } from '@angular/material/dialog';
import { EnovaAlertsComponent } from '../../utils/enova-alerts/enova-alerts.component';
import { EnovaLoadingComponent } from '../../utils/enova-loading/enova-loading.component';
@Injectable({
  providedIn: 'root',
})
export class ConsumeService {
  weekDays: string[] = [
    'Lunes',
    'Martes',
    'Miercoles',
    'Jueves',
    'Viernes',
    'Sabado',
    'Domingo',
  ];

  months: string[] = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ];

  private dateRangeChangedSource = new Subject<void>();
  dateRangeChanged$ = this.dateRangeChangedSource.asObservable();

  constructor(
    private http: HttpService,
    private appSetting: AppSettings,
    private http2: HttpClient,
    private dialog: MatDialog
  ) {}

  async getGeneralStatus() {
    const url: string = `${this.appSetting.consumptionURL}/${CONSUMPTION_SERVICES.STATUS}`;

    try {
      const status = (await this.http.getService(url)) as IConsumptionStatus;
      return status;
    } catch (error) {
      return {
        consumo: 4,
        gnvMasivo: 4,
        perdida: 4, // Violeta por defecto en caso de error
      } as IConsumptionStatus;
    }
  }

  async getAllConsume(
    payload: IConsuptionOptions
  ): Promise<IconsumptionResponse> {
    const diffTime =
      Math.abs(new Date(payload.endDate).getTime()) -
      new Date(payload.startDate).getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    const diffMonths = diffDays / 30;
    if (diffMonths > 3) {
      const midTime =
        (new Date(payload.startDate).getTime() +
          new Date(payload.endDate).getTime()) /
        2;
      const fechaMitad = new Date(midTime).toISOString().split('T')[0];
      const url: string = `${this.appSetting.consumptionURL}/${
        payload.filters
          ? CONSUMPTION_SERVICES.GENERAL_FILTERS
          : CONSUMPTION_SERVICES.GENERAL
      }?fechaInicio=${payload.startDate}&fechaFin=${fechaMitad}${
        payload.filters ? `&${payload.filters}` : ''
      }`;

      const url2: string = `${this.appSetting.consumptionURL}/${
        payload.filters
          ? CONSUMPTION_SERVICES.GENERAL_FILTERS
          : CONSUMPTION_SERVICES.GENERAL
      }?fechaInicio=${fechaMitad}&fechaFin=${payload.endDate}${
        payload.filters ? `&${payload.filters}` : ''
      }`;
      const [data, data2]: any = await Promise.all([
        this.http.getService(url),
        this.http.getService(url2),
      ]);

      const uniqueColumns = Array.from(
        new Set([...data.column, ...data2.column])
      );
      const combinedData = [...data.data, ...data2.data].sort(
        (a, b) => new Date(a.fecha).getTime() - new Date(b.fecha).getTime()
      );

      return {
        column: uniqueColumns,
        data: combinedData,
      };
    } else {
      const url: string = `${this.appSetting.consumptionURL}/${
        payload.filters
          ? CONSUMPTION_SERVICES.GENERAL_FILTERS
          : CONSUMPTION_SERVICES.GENERAL
      }?fechaInicio=${payload.startDate}&fechaFin=${payload.endDate}${
        payload.filters ? `&${payload.filters}` : ''
      }`;

      const response = (await this.http.getService(
        url
      )) as IconsumptionResponse;

      if (Object.keys(response).length === 0) {
        return { column: [], data: [] };
      } else {
        response.data = response.data.sort(
          (a, b) => new Date(a.fecha).getTime() - new Date(b.fecha).getTime()
        );
        return response;
      }
    }
  }

  async getComplexFilters(): Promise<IComplexFilter[]> {
    let tmp: IComplexFilter[] = [];
    const url: string = `${this.appSetting.adminURL}/${ADMIN_SERVICES.COMPLEX_FILTERS}`;
    const response: IComplexFilterResponse = (await this.http.getService(
      url
    )) as IComplexFilterResponse;

    Object.keys(response).forEach(e => {
      tmp.push({
        filterLabel: CONSUMPTION_FILTER_TYPES[e],
        filterInfo: response[e],

        filterName: e,
      });
    });
    return tmp;
  }

  formatNumber = (value: number): string => {
    return new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  };

  indexConsumption(info: Iconsumption[]) {
    let indexedInfo: IconsumptionOBject<any> = {};

    info.forEach(elem => {
      const client = elem.cliente.replace(/\./g, ' ');

      if (!indexedInfo[elem.fecha]) {
        indexedInfo[elem.fecha] = {
          date: elem.fecha.split('-').reverse().join('-'),
          day: this.weekDays[new Date(elem.fecha).getDay()],
          totalmbtu: 0,
          totalm3: 0,
          totalkpc: 0,
          totalm3e: 0,
        } as any;
      }

      const consumption: consumptionValues = {
        uuid: elem.uuid,
        idMedidor: elem.idMedidor,
        origen: elem.origen,
        m3:
          elem.m3 !== undefined && elem.m3 !== null
            ? elem.m3 === 0
              ? '0'
              : this.formatNumber(elem.m3)
            : '-',
        kpc:
          elem.kpc !== undefined && elem.kpc !== null
            ? elem.kpc === 0
              ? '0'
              : this.formatNumber(elem.kpc)
            : '-',
        m3e:
          elem.m3E !== undefined && elem.m3E !== null
            ? elem.m3E === 0
              ? '0'
              : this.formatNumber(elem.m3E)
            : '-',
        mbtu:
          elem.mbtu !== undefined && elem.mbtu !== null
            ? elem.mbtu === 0
              ? '0'
              : this.formatNumber(elem.mbtu)
            : '-',
        pc:
          elem.pc !== undefined && elem.pc !== null
            ? elem.pc === 0
              ? '0'
              : elem.pc
            : '-',
      };

      indexedInfo[elem.fecha][client] = consumption;

      if (elem.mbtu !== undefined && elem.mbtu !== null) {
        indexedInfo[elem.fecha].totalmbtu += elem.mbtu;
      }
      if (elem.m3 !== undefined && elem.m3 !== null) {
        indexedInfo[elem.fecha].totalm3 += elem.m3;
      }
      if (elem.kpc !== undefined && elem.kpc !== null) {
        indexedInfo[elem.fecha].totalkpc += elem.kpc;
      }
      if (elem.m3E !== undefined && elem.m3E !== null) {
        indexedInfo[elem.fecha].totalm3e += elem.m3E;
      }
    });

    const sortedIndexedInfo = Object.keys(indexedInfo)
      .sort((a, b) => new Date(a).getTime() - new Date(b).getTime())
      .reduce((result, key) => {
        result[key] = indexedInfo[key];
        return result;
      }, {} as IconsumptionOBject<tableInfo>);

    return sortedIndexedInfo;
  }

  async getMassConsumption(startDate: string, endDate: string) {
    return await this.http.httpGet(
      CONSUMPTION_SERVICES.MASSIVE,
      `?fechaInicio=${startDate}&fechaFin=${endDate}`
    );
  }

  indexMassiveConsumption(info: IMassiveConsumptionResponse[]) {
    let indexedMassive: IconsumptionOBject<IMassiveConsumeTable> = {};

    info.forEach(e => {
      const consume: IMassiveConsumeTable = {
        date: e.fecha,
        day: this.weekDays[new Date(e.fecha).getDay()],
      };
      if (!indexedMassive[e.fecha]) {
        indexedMassive[e.fecha] = consume;
        indexedMassive[e.fecha].TRANSMILENIO = {
          kpc: 0,
          m3: 0,
          m3E: 0,
          mbtu: 0,
        };
        indexedMassive[e.fecha].SITP = {
          kpc: 0,
          m3: 0,
          m3E: 0,
          mbtu: 0,
          pc: 0,
        };
      }

      indexedMassive[e.fecha][e.tipo] = {
        kpc: e.kpc,
        m3: e.m3,
        m3E: e.m3E,
        mbtu: e.mbtu,
        pc: e.pc,
      };
    });

    Object.keys(indexedMassive).forEach(date => {
      indexedMassive[date].total = {
        kpc:
          Number(indexedMassive[date].SITP?.kpc) +
          Number(indexedMassive[date].TRANSMILENIO?.kpc),
        m3:
          Number(indexedMassive[date].SITP?.m3) +
          Number(indexedMassive[date].TRANSMILENIO?.m3),
        m3E:
          Number(indexedMassive[date].SITP?.m3E) +
          Number(indexedMassive[date].TRANSMILENIO?.m3E),
        mbtu:
          Number(indexedMassive[date].SITP?.mbtu) +
          Number(indexedMassive[date].TRANSMILENIO?.mbtu),
      };

      indexedMassive[date].PC = {
        pc: Number(indexedMassive[date].SITP?.pc),
      };
    });
    return indexedMassive;
  }

  async getLossPercentage(
    initialDate: string,
    endDate: string,
    type?: (typeof LOSS_TYPES)[keyof typeof LOSS_TYPES]
  ) {
    if (!type) {
      let promisesArray: Array<Promise<ILossPercentageResponse>> = [];
      promisesArray.push(
        this.http.httpGet(
          CONSUMPTION_SERVICES.LOSS_STATUS,
          `?tipo=${LOSS_TYPES.PROJECTED}&fechaInicio=${initialDate}&fechaFin=${endDate}`
        )
      );
      promisesArray.push(
        this.http.httpGet(
          CONSUMPTION_SERVICES.LOSS_STATUS,
          `?tipo=${LOSS_TYPES.REGULATORY}&fechaInicio=${initialDate}&fechaFin=${endDate}`
        )
      );
      return await Promise.all(promisesArray);
    } else {
      return await this.http.httpGet(
        CONSUMPTION_SERVICES.LOSS_STATUS,
        `?tipo=${type}&fechaInicio=${initialDate}&fechaFin=${endDate}`
      );
    }
  }

  async getLossPercentageTableValues(
    initialDate: string,
    endDate: string,
    type?: (typeof LOSS_TYPES)[keyof typeof LOSS_TYPES]
  ) {
    return await this.http.httpGet(
      CONSUMPTION_SERVICES.LOSS,
      `?tipo=${type}&fechaInicio=${initialDate}&fechaFin=${endDate}`
    );
  }

  async getLossPercentageHistorical(
    initialDate: string,
    endDate: string,
    mercadoRel: string,
    type?: (typeof LOSS_TYPES)[keyof typeof LOSS_TYPES]
  ) {
    return await this.http.httpGet(
      CONSUMPTION_SERVICES.LOSS,
      `historical?tipo=${type}&fechaInicio=${initialDate}&fechaFin=${endDate}&mercadoRel=${mercadoRel}`
    );

    // /msconsumos/perdida/historical?periodo=2017-03&tipo=proyectada
  }

  notifyDateRangeChanged() {
    this.dateRangeChangedSource.next();
  }
  indexLossPercentage(info: any[]): ILossTable[] {
    let indexedLoss: ILossTable[] = [];

    info.forEach(loss => {
      const name = loss.nombre.replace(/\./g, ' ');
      const losses: ILossInfo = {
        uuid: loss.uuid,
        tipo: loss.tipo,
        periodo: loss.periodo,
        porcentajePerdida: loss.porcentajePerdida,
        estado: loss.estado,
        version: loss.version,
        fechaActualizacion: new Date(loss['fechaActualizacion']),
        usuario: loss.usuario,
        mercadoRel: loss.mercadoRel,
        nombre: loss.nombre,
      };

      const dateParts = loss.periodo.split('-');
      const year = parseInt(dateParts[0]);
      const month = parseInt(dateParts[1]) - 1;
      const monthName = new Date(year, month).toLocaleDateString('es', {
        month: 'long',
      });
      const capitalizedMonthName =
        monthName.charAt(0).toUpperCase() + monthName.slice(1);

      let existingRow = indexedLoss.find(
        row =>
          row.month === capitalizedMonthName &&
          row.year === year.toString() &&
          !(name in row)
      );

      if (existingRow) {
        existingRow[name] = losses;
      } else {
        const newRow: ILossTable = {
          month: capitalizedMonthName,
          year: year.toString(),
          [name]: losses,
        };
        indexedLoss.push(newRow);
      }
    });

    indexedLoss.sort((a, b) => {
      const getMonthValue = (monthName: string): number => {
        const months = [
          'Enero',
          'Febrero',
          'Marzo',
          'Abril',
          'Mayo',
          'Junio',
          'Julio',
          'Agosto',
          'Septiembre',
          'Octubre',
          'Noviembre',
          'Diciembre',
        ];
        return months.indexOf(monthName);
      };

      const yearA = parseInt(a.year);
      const yearB = parseInt(b.year);
      const monthA = getMonthValue(a.month);
      const monthB = getMonthValue(b.month);

      if (yearA === yearB) {
        if (monthA === monthB) {
          const lossA = Object.values(a).find(
            v => typeof v === 'object'
          ) as ILossInfo;
          const lossB = Object.values(b).find(
            v => typeof v === 'object'
          ) as ILossInfo;

          if (lossA && lossB) {
            return (
              new Date(lossB.fechaActualizacion).getTime() -
              new Date(lossA.fechaActualizacion).getTime()
            );
          }
          return 0;
        }
        return monthB - monthA;
      } else {
        return yearB - yearA;
      }
    });

    return indexedLoss;
  }

  async updateLoss(data: IlossPercentageUpdate) {
    const res = this.http.httpPost(CONSUMPTION_SERVICES.LOSS_STATUS, {
      ...data,
      usuario: 'system',
    });
    return await res;
  }

  async getHistoricChanges(
    uuid: string,
    date: string
  ): Promise<IconsumptionHistoric[]> {
    const formattedStartDate = date.split('-').reverse().join('-');

    const url: string = `${this.appSetting.consumptionURL}/${CONSUMPTION_SERVICES.HISTORIC}?uuid=${uuid}&fecha=${formattedStartDate}`;
    const historic = (await this.http.getService(
      url
    )) as IconsumptionHistoric[];
    return historic;
  }

  async getConsolidatesData(
    startDate: string,
    endDate: string,
    filters?: string
  ): Promise<IConsolidate[]> {
    const url: string = `${this.appSetting.consumptionURL}/${
      CONSUMPTION_SERVICES.CONSOLIDATED
    }?fechaInicio=${startDate}&fechaFin=${endDate}${
      filters ? `&${filters}` : ''
    }`;
    const consolidate = (await this.http.getService(url)) as IConsolidate[];
    return consolidate;
  }

  indexedConsolidate(consolidate: IConsolidate[]): {
    indexedData: IconsumptionOBject<IConsolidateData>;
    cols: string[];
  } {
    let cols: string[] = [];
    let indexedData: IconsumptionOBject<IConsolidateData> = {};
    consolidate.forEach(e => {
      const date = e.fecha.split('T')[0];
      let obj: IConsolidateData = {
        date: date.split('-').reverse().join('-'),
        day: this.weekDays[new Date(date).getDay()],
        total: '0',
      };
      for (let ind in e) {
        if (ind !== 'fecha') {
          if (cols.findIndex(col => col === ind) === -1) cols.push(ind);
          obj[ind] = Number(e[ind]).toFixed(2);
          obj.total = `${(Number(obj.total) + Number(e[ind])).toFixed(2)}`;
        }
      }
      indexedData[date] = obj;
    });

    return { indexedData, cols };
  }

  exportConsumesReport(
    fechaInicio: string,
    fechaFin: string,
    unidad: string,
    filters: string,
    pc: boolean = true,
    client?: string
  ): Observable<Blob> {
    let params = `fechaInicio=${fechaInicio}&fechaFin=${fechaFin}&unidad=${unidad}`;
    if (filters) {
      params += `&${filters}`;
    }
    if (pc) {
      params += `&pc=${pc}`;
    }
    if (client) {
      params += `&cliente=${client}`;
    }

    const url: string = `${this.appSetting.consumptionURL}/consumo/download?${params}`;

    return this.http2.get(url, { responseType: 'blob' });
  }
  downloadExcelReport(
    fechaInicio: string,
    fechaFin: string,
    unidad: string,
    filters?: any,
    pc?: boolean,
    client?: string
  ): void {
    const dialogRef = this.dialog.open(EnovaLoadingComponent, {
      disableClose: true,
      panelClass: 'loading-spinner-panel',
    });

    this.exportConsumesReport(
      fechaInicio,
      fechaFin,
      unidad,
      filters,
      pc,
      client
    )
      .pipe(
        finalize(() => {
          dialogRef.close();
        })
      )
      .subscribe({
        next: blob => {
          const link = document.createElement('a');
          const url = window.URL.createObjectURL(blob);
          link.href = url;
          link.download = `reporte_consumos_${fechaInicio}_a_${fechaFin}.xlsx`;

          document.body.appendChild(link);
          link.click();

          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
        },
        error: error => {
          console.error('Error descargando el archivo:', error);
        },
      });
  }

  exportGNVReport(
    fechaInicio: string,
    fechaFin: string,
    unidad: string,
    pc?: boolean
  ): Observable<Blob> {
    let params = `fechaInicio=${fechaInicio}&fechaFin=${fechaFin}&unidad=${unidad}`;

    if (pc) {
      params += `&pc=${pc}`;
    }

    const url: string = `${this.appSetting.consumptionURL}/consumo/gnvmas/download?${params}`;

    return this.http2.get(url, { responseType: 'blob' });
  }

  downloadGNVExcelReport(
    fechaInicio: string,
    fechaFin: string,
    unidad: string,
    pc?: boolean
  ): void {
    const dialogRef = this.dialog.open(EnovaLoadingComponent, {
      disableClose: true,
      panelClass: 'loading-spinner-panel',
    });

    this.exportGNVReport(fechaInicio, fechaFin, unidad, pc)
      .pipe(
        finalize(() => {
          dialogRef.close();
        })
      )
      .subscribe({
        next: blob => {
          const link = document.createElement('a');
          const url = window.URL.createObjectURL(blob);
          link.href = url;
          link.download = `reporte_gnv_masivo_${fechaInicio}_a_${fechaFin}.xlsx`;

          document.body.appendChild(link);
          link.click();

          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
        },
        error: error => {
          console.error('Error descargando el archivo:', error);
        },
      });
  }

  exportPerdidasReport(
    fechaInicio: string,
    fechaFin: string,
    tipo: string
  ): Observable<Blob> {
    const url: string = `${this.appSetting.consumptionURL}/perdida/download?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}&tipo=${tipo}`;

    return this.http2.get(url, { responseType: 'blob' });
  }

  downloadPerdidasExcelReport(
    fechaInicio: string,
    fechaFin: string,
    tipo: string
  ): void {
    const dialogRef = this.dialog.open(EnovaLoadingComponent, {
      disableClose: true,
      panelClass: 'loading-spinner-panel',
    });

    this.exportPerdidasReport(fechaInicio, fechaFin, tipo)
      .pipe(
        finalize(() => {
          dialogRef.close();
        })
      )
      .subscribe({
        next: blob => {
          const link = document.createElement('a');
          const url = window.URL.createObjectURL(blob);
          link.href = url;
          link.download = `reporte_perdida_${tipo}_${fechaInicio}_a_${fechaFin}.xlsx`;

          document.body.appendChild(link);
          link.click();

          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
        },
        error: error => {
          console.error('Error descargando el archivo:', error);
        },
      });
  }

  exportConsolidadoReport(
    fechaInicio: string,
    fechaFin: string,
    filters?: any
  ): Observable<Blob> {
    const url: string = `${this.appSetting.consumptionURL}/consolidado/download?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}&${
      filters ? `&${filters}` : ''
    }`;

    return this.http2.get(url, { responseType: 'blob' });
  }

  downloadConsolidadoExcelReport(
    fechaInicio: string,
    fechaFin: string,
    filters?: any
  ): void {
    const dialogRef = this.dialog.open(EnovaLoadingComponent, {
      disableClose: true,
      panelClass: 'loading-spinner-panel',
    });

    this.exportConsolidadoReport(fechaInicio, fechaFin, filters)
      .pipe(
        finalize(() => {
          dialogRef.close();
        })
      )
      .subscribe({
        next: blob => {
          const link = document.createElement('a');
          const url = window.URL.createObjectURL(blob);
          link.href = url;
          link.download = `reporte_consumos_consolidado_${fechaInicio}_a_${fechaFin}.xlsx`;

          document.body.appendChild(link);
          link.click();

          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
        },
        error: error => {
          console.error('Error descargando el archivo:', error);
        },
      });
  }

  private transformFilters(filters: string | any[] | undefined): string {
    if (!filters) return '';
    
    // Si filters es un array, convertirlo a string
    const filtersStr = Array.isArray(filters) ? filters.join('&') : filters;
    
    // Dividir los filtros en partes
    const filterParts = filtersStr.split('&');
    
    // Transformar cliente=XXX a idMedidor=XXX
    const transformedParts = filterParts.map(part => {
      if (part.startsWith('cliente=')) {
        const value = part.split('=')[1];
        return `idMedidor=${value}`;
      }
      return part;
    });
    
    return transformedParts.join('&');
  }

  async getAtrData(payload: IConsuptionOptions): Promise<any> {
    const transformedFilters = this.transformFilters(payload.filters);
    const url: string = `${this.appSetting.consumptionURL}/consumo/atr?fechaInicio=${payload.startDate}&fechaFin=${payload.endDate}${
      transformedFilters ? `&${transformedFilters}` : ''
    }`;
    const response = (await this.http.getService(url)) as any;

    const data = response.data;
    return data;
  }

  async getGiData(payload: IConsuptionOptions): Promise<any> {
    const transformedFilters = this.transformFilters(payload.filters);
    const url: string = `${this.appSetting.consumptionURL}/consumo/gi?fechaInicio=${payload.startDate}&fechaFin=${payload.endDate}${
      transformedFilters ? `&${transformedFilters}` : ''
    }`;
    const response = (await this.http.getService(url)) as any;

    const data = response.data;
    return data;
  }
}

const mockAtr = {
  data: [
    {
      fecha: '12/06/2024',
      clientes: {
        'Terpel Alquería': {
          mercado: 'Gas Natural Vehicular',
          mbtuPP: 1000,
          mbtuPR: 900,
          prima: 100,
        },
        'Otro Cliente': {
          mercado: 'Gas Natural Vehicular',
          mbtuPP: 500,
          mbtuPR: 450,
          prima: 50,
        },
      },
    },
    {
      fecha: '13/06/2024',
      clientes: {
        'Terpel Alquería': {
          mercado: 'Gas Natural Vehicular',
          mbtuPP: 850,
          mbtuPR: 832,
          prima: 18,
        },
        'Otro Cliente': {
          mercado: 'Gas Natural Vehicular',
          mbtuPP: 600,
          mbtuPR: 580,
          prima: 20,
        },
      },
    },
    {
      fecha: '14/06/2024',
      clientes: {
        'Terpel Alquería': {
          mercado: 'Gas Natural Vehicular',
          mbtuPP: 788,
          mbtuPR: 786,
          prima: 2,
        },
        'Otro Cliente': {
          mercado: 'Gas Natural Vehicular',
          mbtuPP: 650,
          mbtuPR: 630,
          prima: 20,
        },
      },
    },
  ],
};
